import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/web/lib/auth.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/web/node_modules/react-hot-toast/dist/index.mjs");
